// Název v horní liště. U chatu a pohledu jde kliknutím přejmenovat (Enter uloží, Esc zruší).
import { useEffect, useRef, useState } from 'react';
import { useToast } from '@smworks-cz/ui-kit';

interface Props {
  title: string;
  /** Bez onRename je název jen text. */
  onRename?: (title: string) => Promise<void>;
}

export function TopTitle({ title, onRename }: Props) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(title);
  const [saving, setSaving] = useState(false);
  const input = useRef<HTMLInputElement>(null);
  const { toast } = useToast();

  useEffect(() => {
    if (!editing) setValue(title);
  }, [title, editing]);

  useEffect(() => {
    if (editing) {
      input.current?.focus();
      input.current?.select();
    }
  }, [editing]);

  if (!onRename) return <h1 className="top-title">{title}</h1>;

  const commit = async () => {
    const t = value.trim();
    if (!t || t === title) {
      setEditing(false);
      return;
    }
    setSaving(true);
    try {
      await onRename(t.slice(0, 120));
      setEditing(false);
    } catch (e) {
      toast({ variant: 'error', title: (e as Error).message });
    } finally {
      setSaving(false);
    }
  };

  if (editing) {
    return (
      <input
        ref={input}
        className="top-title-input"
        value={value}
        maxLength={120}
        disabled={saving}
        aria-label="Název"
        onChange={(e) => setValue(e.target.value)}
        onBlur={() => void commit()}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            void commit();
          } else if (e.key === 'Escape') {
            e.preventDefault();
            setValue(title);
            setEditing(false);
          }
        }}
      />
    );
  }
  return (
    <h1 className="top-title">
      <button type="button" className="top-title-btn" onClick={() => setEditing(true)} title="Kliknutím přejmenujete">
        {title}
      </button>
    </h1>
  );
}
